import { render, staticRenderFns } from "./LoyaltyHeader.vue?vue&type=template&id=a0e9fe8e&scoped=true"
import script from "./LoyaltyHeader.vue?vue&type=script&lang=js"
export * from "./LoyaltyHeader.vue?vue&type=script&lang=js"
import style0 from "./LoyaltyHeader.vue?vue&type=style&index=0&id=a0e9fe8e&prod&lang=css"
import style1 from "./LoyaltyHeader.vue?vue&type=style&index=1&id=a0e9fe8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0e9fe8e",
  null
  
)

export default component.exports